import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { MailIcon, PhoneIcon } from "lucide-react";
import { CONTACT_INFO } from "@/lib/constants";

export default function Home() {
  return (
    <>
      {/* Hero Section */}
      <div className="relative">
        <div className="w-full h-[80vh] bg-gray-200 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1465847899084-d164df4dedc6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80" 
            alt="Clyde Wind Ensemble performing" 
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#4A1D6E]/70 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
            <h2 className="font-['Playfair_Display'] text-4xl md:text-6xl text-white font-bold mb-4">Clyde Wind Ensemble</h2>
            <p className="text-xl md:text-2xl text-white font-light max-w-3xl">Welcome</p>
          </div>
        </div>
      </div>
      
      {/* Welcome Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-lg md:text-xl leading-relaxed mb-8">
            Welcome to the website of Clyde Wind Ensemble – one of Scotland's leading community concert bands. Performing at a high level, we give concerts throughout the year and participate in National Concert Band Festivals.
          </p>
          
          <p className="text-lg md:text-xl leading-relaxed mb-8">
            The band rehearse on a Thursday evening 7pm – 9pm at Calderglen High School, East Kilbride, G74 2LP, and we look forward to welcoming any new perspective players.
          </p>
          
          <div className="mt-12 space-x-4">
            <Link href="/join">
              <a>
                <Button className="bg-[#4A1D6E] hover:bg-[#7A5195] text-white font-medium py-3 px-8 rounded-md transition duration-300 shadow-md hover:shadow-lg">
                  Join the Band
                </Button>
              </a>
            </Link>
            <Link href="/events">
              <a>
                <Button variant="outline" className="border-2 border-[#4A1D6E] text-[#4A1D6E] hover:bg-[#4A1D6E] hover:text-white font-medium py-3 px-8 rounded-md transition duration-300">
                  Upcoming Events
                </Button>
              </a>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Contact Section */}
      <div className="bg-[#F8F8F8] py-16">
        <div className="container mx-auto px-4">
          <h2 className="font-['Playfair_Display'] text-3xl text-center mb-12 text-[#4A1D6E]">Contact Us</h2>
          
          <div className="max-w-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="text-center md:text-left">
              <div className="mb-6">
                <div className="flex justify-center md:justify-start mb-3">
                  <MailIcon className="text-[#D4AF37] h-6 w-6" />
                </div>
                <h3 className="text-xl font-medium mb-2">Email</h3>
                <a href={`mailto:${CONTACT_INFO.email}`} className="text-gray-600 hover:text-[#4A1D6E]">
                  {CONTACT_INFO.email}
                </a>
              </div>
            </div>
            
            <div className="text-center md:text-left">
              <div className="mb-6">
                <div className="flex justify-center md:justify-start mb-3">
                  <PhoneIcon className="text-[#D4AF37] h-6 w-6" />
                </div>
                <h3 className="text-xl font-medium mb-2">Phone</h3>
                <p className="text-gray-600">{CONTACT_INFO.phone.join(' / ')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
